import { P, SharedColors, SharedGradients } from "apparatus/library/common";
import { Group, Path, PointText } from "paper";
const MARKING_COLOR = "#666666";
export class Protractor {
    render(appearance) {
        const { labels: markings } = appearance;
        const base = new Path();
        base.moveTo(P(-50, 10));
        base.lineTo(P(-50, 0));
        base.arcTo(P(50, 0));
        base.lineTo(P(50, 10));
        base.close();
        base.withStroke("default", SharedColors.stroke).withGradientFill("right-down", SharedGradients.glass);
        const graphic = new Group([
            base,
            new Path.Arc(P(-10, 0), P(0, -10), P(10, 0)).withStroke(1.0, MARKING_COLOR),
            new Path.Arc(P(-35, 0), P(0, -35), P(35, 0)).withStroke(1.0, MARKING_COLOR),
        ]);
        // Add markings.
        const innerLineBase = new Path.Line(P(-10, 0), P(-35, 0)).withStroke(1.0, MARKING_COLOR);
        const outerLineBase = new Path.Line(P(-47, 0), P(-50, 0)).withStroke(1.0, MARKING_COLOR);
        for (let i = 0; i <= 18; i++) {
            const angle = i * 10;
            const innerLine = innerLineBase.clone();
            if (i % 9 == 0)
                innerLine.segments[0].point.x = 0;
            innerLine.rotate(angle, P(0, 0));
            const outerLine = outerLineBase.clone();
            outerLine.rotate(angle, P(0, 0));
            graphic.addChild(innerLine);
            graphic.addChild(outerLine);
            if (markings == "all" || (markings == "every-second" && i % 2 == 0)) {
                // Larger font if only every second marking is shown.
                const fontSize = markings == "all" ? 4 : 5.5;
                const compression = markings == "all" ? 0.8 : 0.9;
                const label = new PointText({
                    point: P(0, -40),
                    content: angle,
                    fillColor: 'black',
                    fontFamily: 'sans-serif',
                    fontSize: fontSize,
                    justification: 'center'
                });
                if (i == 9) {
                    label.fontWeight = 'bold';
                }
                label.scale(compression, 1.0);
                label.rotate(-90 + angle, P(0, 0));
                graphic.addChild(label);
            }
        }
        if (appearance.degree45) {
            const degree45 = innerLineBase.clone();
            degree45.segments[0].point.x = 0;
            degree45.dashArray = [5, 3];
            degree45.rotate(45, P(0, 0));
            const degree135 = degree45.clone();
            degree135.rotate(90, P(0, 0));
            graphic.addChildren([degree45, degree135]);
        }
        innerLineBase.remove();
        outerLineBase.remove();
        graphic.scale(appearance.scale);
        return {
            graphic,
            hitShape: graphic.bounds.toShape()
        };
    }
}
Protractor.properties = {
    label: "Protractor",
    defaultAppearance: {
        scale: 2.0,
        labels: "every-second",
        degree45: true,
    },
    appearanceSpecs: [
        {
            spec: "slider", key: "scale", label: "Scale",
            min: 1.0, max: 3.0, step: 0.1, unit: "%",
        },
        {
            spec: "radio", key: "labels", label: "Labels",
            options: [
                { value: "off", label: "None" },
                { value: "every-second", label: "protractor.20" },
                { value: "all", label: "protractor.10" },
            ],
        },
        {
            spec: "checkbox-group", label: "Markings", checkboxes: [
                { key: "degree45", label: "protractor.45-135" }
            ]
        },
    ],
};
